import React from 'react';
import { get } from 'lodash';

import styles from './onboardingCommunitySuggestionsStyles';

import PaginatedIndex, {
  PaginatedIndexItems,
  PaginationButton
} from 'buyside/components/presentation/Index/paginatedIndex';
import OnboardingCommunitySuggestionCard from 'buyside/components/presentation/Onboarding/OnboardingForm/OnboardingCommunitySuggestionCard/onboardingCommunitySuggestionCard';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

class OnboardingCommunitySuggestions extends React.Component {
  constructor() {
    super();
    this.state = { page: 1, maxPage: 1, fetching: false };
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.goBackOnePage = this.goBackOnePage.bind(this);
  }

  fetchNextPage() {
    const { data = {} } = this.props;
    const { page, maxPage } = this.state;
    if (maxPage === page) {
      this.setState({ fetching: true });
      return data
        .fetchNextPage()
        .then(() => this.setState({ page: page + 1, maxPage: page + 1, fetching: false }));
    } else {
      return this.setState({ page: page + 1 });
    }
  }

  goBackOnePage() {
    this.setState({ page: this.state.page - 1 });
  }

  render() {
    const { data, pageSize } = this.props;

    const { page, maxPage, fetching } = this.state;
    const { hasNextPage, recommendedUsersToFollow = {} } = data;

    const indexItems = recommendedUsersToFollow.edges.slice(
      page * pageSize - pageSize,
      page * pageSize
    );

    return (
      <div>
        <h3 className={styles.fieldHeader}>Recommended Analysts</h3>
        <PaginatedIndex
          indexItems={indexItems}
          indexItemRenderer={indexItem => (
            <OnboardingCommunitySuggestionCard
              key={indexItem.node.id}
              suggestion={indexItem.node}
              disabled={fetching}
              showUserDetails={get(data, ['currentUser', 'canViewUserDetails'])}
            />
          )}
          hasNextPage={hasNextPage || page !== maxPage}
          fetchNextPage={this.fetchNextPage}
        >
          <div className={`${styles.wrapper} ${fetching ? styles.fetching : ''}`}>
            <PaginatedIndexItems className={styles.indexArea} />
            {fetching && <div className={styles.loading} />}
          </div>
          <div className={styles.buttonArea}>
            <Button
              text="<< Previous Page"
              size={BUTTON_SIZES.SMALL}
              isLoading={fetching}
              disabled={page === 1}
              type={BUTTON_TYPES.LINK}
              onClick={this.goBackOnePage}
            />
            <PaginationButton hideLoading>
              <Button
                text="Show More >>"
                size={BUTTON_SIZES.SMALL}
                isLoading={fetching}
                type={BUTTON_TYPES.LINK}
              />
            </PaginationButton>
          </div>
        </PaginatedIndex>
      </div>
    );
  }
}

export default OnboardingCommunitySuggestions;
